import React from 'react';
import { TextareaAutosize } from '@material-ui/core';
import MarkdownFormat from '../../../components/MarkdownFormat';

const ContentEditor = ({ content, setContent, isRequired = false }) => {
  return (
    <div className="education__course__edit__form__content">
      <div className="education__course__edit__form__content__form">
        <label>Content</label>
        <TextareaAutosize required={isRequired} value={content} onChange={e => setContent(e.target.value)} />
      </div>
      <div className="education__course__edit__form__content__preview">
        <label>Preview</label>
        <div className="education__course__edit__form__content__preview__markdown">
          <MarkdownFormat content={content} />
        </div>
      </div>
    </div>
  );
};

export default ContentEditor;
